<template>
    <tr>
      <!-- title -->
      <td class="text-left ml-5">
        <router-link class="color-default" :to="'/brochure/' + brochure.slug">{{ brochure.title }}</router-link>
      </td>
      <td v-if="brochure.published == 1">
        <span class="text-success font-weight-bold">Yes</span>
      </td>
      <td v-else>
        <span class="text-danger font-weight-bold">No</span>
      </td>
      <td v-if="brochure.featured == 1">
        <span class="text-success font-weight-bold">Yes</span>
      </td>
      <td v-else>
        <span class="text-danger font-weight-bold">No</span>
      </td>
      <!-- controls [Update, Delete] -->
      <td>
        <a class="btn dropdown-toggle" data-toggle="dropdown" href="#">
          <span class="fas fa-ellipsis-v"></span>
        </a>
        <ul class="dropdown-menu">
          <router-link class="dropdown-item" :to="'/brochure/edit/' + brochure.slug">Update</router-link>
          <template>
            <a class="dropdown-item" v-if="brochure.published == 0" @click="publishing('publish')">Publish</a>
            <a class="dropdown-item" v-else @click="publishing('unpublish')">Unpublish</a>
          </template>
          <a class="dropdown-item text-danger" @click="deleteBrochure">Delete</a>
        </ul>
      </td>
    </tr>
  </template>
  
  <script>
    export default {
      name: "FAQRow",
      props: ["brochure", "pageNumber"],
      computed: {
        author: function () {
          if (typeof this.brochure.author === "undefined") {
            return "unknown";
          }
          return this.brochure.author.name;
        },
      },
      methods: {
        publishing(action) {
          this.$store
            .dispatch("brochures/publishing", {
              brochure: this.brochure,
              action: action,
            })
            .then((response) => { 
              if(response.data.data.published == 1) {
                this.$toast.success('Brochure published successfully!');
              } else {
                this.$toast.success('Brochure unpublished successfully!');
              }
             
            });
        },
        deleteBrochure() {
          this.$store.dispatch("message/update", {
            title: this.brochure.title,
            body: "Are you sure you want to delete this brochure?",
            class: "danger",
            confirm: true,
          });
  
          this.$bus.$off("proceed");
          this.$bus.$once("proceed", () => {
            this.delete(this.brochure);
            this.$store.dispatch("message/close");
          });
        },
        delete(brochure) {
          this.$store.dispatch("brochures/delete", brochure)
            .then(() => {
              this.$parent.$parent.getBrochures(this.pageNumber,'');
              this.$toast.success('Brochure deleted successfully!');
            })
            .catch((error) => {
              // send error message
              this.$toast.success(error.response.data.message);
            });
        },
      },
    };
  </script>
  <style scoped>
    table tr td:nth-child(1) {
      width: 35% !important;
      padding-left: 40px;
    }
  
    table tr td:nth-child(2) {
      width: 35% !important;
    }
  
    table tr td:nth-child(3) {
      width: 20% !important;
    }
  
    table tr td:nth-child(4) {
      width: 10% !important;
    }
  </style>